import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { AppConfiguration } from "read-appsettings-json"
import { IsEnglish } from '../../utils/language'
import Iframe from 'react-iframe'
import i18next from 'i18next'
import { withNamespaces } from 'react-i18next'
import Typography from '@material-ui/core/Typography'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import Dialog from '@material-ui/core/Dialog'
import CloseIcon from '@material-ui/icons/Close'
import Slide from '@material-ui/core/Slide'
import * as TypeHelpOnline from '../../scripts/TypeHelpOnline'
import * as storage from '../../utils/storage'
import styles from '../../styles/helpOnline.module.css'


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
    },
    titleAppBar: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
}));


function HelpOnline(props) {

    const classes = useStyles();

    const [title, setTitle] = useState('');
    const [urlHelp, setUrlHelp] = useState('');
    const [open, setOpen] = useState(false);

    useEffect(() => {
        setOpen(props.open);
    }, [props.open]);

    useEffect(() => {
        if (open) {
            loadUrl(props.typeHelp);
            resizeForm();
        }
    }, [open]);


    const resizeForm = () => {
        setTimeout(function () {
            const element = document.querySelector('#divFrameHelpOnline');

            const height = window.innerHeight;

            const offSet = 60;

            const customHeight = height - offSet;

            if (element !== null) {
                document.querySelector('#helpOnlineFrame').style.height = `${customHeight}px`;
                document.querySelector('#helpOnlineFrame').style.overflowX = 'hidden';
            }
        }, 50);
    }

    const loadUrl = (typeHelp) => {
        let title = '';
        let urlHelp = '';
        if (typeHelp === TypeHelpOnline.Legal_Information) {
            title = i18next.t('helpOnline:title.legal-information');
            urlHelp = storage.getLegalInfo();
        }

        setTitle(title);
        setUrlHelp(urlHelp);
        setOpen(props.open);
    }

    const handleCloseClick = () => {
        props.handleClose();
    };

    return (
        <div id="divHelpOnline">
            <Dialog fullScreen open={open} onClose={handleCloseClick} TransitionComponent={Transition}>
                <div data-id="headerTimesheetForm">
                    <AppBar className={classes.appBar}>
                        <Toolbar>
                            <IconButton edge="start" color="inherit" onClick={handleCloseClick} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" className={classes.titleAppBar}>
                                {title}
                            </Typography>
                        </Toolbar>
                    </AppBar>
                </div>
                <div id="divFrameHelpOnline">
                    <Iframe url={urlHelp}
                        id="helpOnlineFrame"
                        className={styles.iframe}
                        display="initial"
                        scrolling="yes"
                        position="relative" />
                </div>
            </Dialog>
        </div>
    );
}

export default withNamespaces(['helpOnline'], { wait: true })(HelpOnline);